function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.9375 2.625H13.8125V0.5H10.625V2.625H6.375V0.5H3.1875V2.625H1.0625C0.476 2.625 0 3.101 0 3.6875V16.4375C0 17.024 0.476 17.5 1.0625 17.5H15.9375C16.524 17.5 17 17.024 17 16.4375V3.6875C17 3.101 16.524 2.625 15.9375 2.625ZM14.875 15.375H2.125V5.8125H14.875V15.375Z",
  fill: "#767B87"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.375 7.9375H4.25V10.0625H6.375V7.9375Z",
  fill: "#767B87"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5625 7.9375H7.4375V10.0625H9.5625V7.9375Z",
  fill: "#767B87"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.375 11.125H4.25V13.25H6.375V11.125Z",
  fill: "#767B87"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5625 11.125H7.4375V13.25H9.5625V11.125Z",
  fill: "#767B87"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.75 7.9375H10.625V10.0625H12.75V7.9375Z",
  fill: "#767B87"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.75 11.125H10.625V13.25H12.75V11.125Z",
  fill: "#767B87"
});

const SvgDatePickerIcon = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDatePickerIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DatePickerIcon.33f72f3b.svg";
export { ForwardRef as ReactComponent };